import { useCallback } from 'react';

// Web: camera is disabled
const useCameraPermissionOnFocus = () => {
  const requestPermission = useCallback(async () => false, []);
  return { hasPermission: false, requestPermission } as const;
};

export default useCameraPermissionOnFocus;
